export async function stringToSha256(value: string) {
  const buffer = new TextEncoder().encode(value)

  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('')
}
